import FordVehicleDetailsSchema from './FordVehicleDetailsSchema';

export default FordVehicleDetailsSchema;
